import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getAllBookings, confirmBooking } from "./bookings.service";

export const useGetAllBookings = () => {
  return useQuery({
    queryKey: ["bookings"],
    queryFn: getAllBookings,
  });
}

export const useConfirmBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: confirmBooking,   
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
    }
  })
}